import React, { useState } from 'react';
import { Product } from '../types/product';
import CreateOrderFromStockModal from '../ui/pages/Stock/Product/Detail/Info/CreateOrderFromStockModal';

interface CreateOrderFromStockModalContextProps {
  openCreateOrderFromStockModal: (product: Product) => void;
}

const defaultContext: CreateOrderFromStockModalContextProps = {
  openCreateOrderFromStockModal: (product: Product) => {},
};

export const CreateOrderFromStockModalContext =
  React.createContext<CreateOrderFromStockModalContextProps>(defaultContext);

interface ModalProps {
  open: boolean;
  product?: Product;
}

export default function CreateOrderFromStockModalProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState<Product | undefined>(undefined);

  const context = {
    openCreateOrderFromStockModal: (product: Product) => {
      setProduct(product);
      setOpen(true);
    },
  };

  return (
    <CreateOrderFromStockModalContext.Provider value={context}>
      {children}
      {open && product && <CreateOrderFromStockModal open={open} setOpen={setOpen} product={product} />}
    </CreateOrderFromStockModalContext.Provider>
  );
}
